export const QA_NAME_PAGINATION_DATA_SECTION = 'PaginationSection'

export const QA_NAME_PAGINATION = 'pagination'

export const QA_NAME_PAGINATION_NEXT = 'next'

export const QA_NAME_PAGINATION_PREV = 'prev'
